// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AceEditorController from "./ace_editor_controller"
application.register("ace-editor", AceEditorController)

import AddFieldController from "./add_field_controller"
application.register("add-field", AddFieldController)

import AuctionStartScheduleController from "./auction_start_schedule_controller"
application.register("auction-start-schedule", AuctionStartScheduleController)

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import AgeRangeController from "./age_range_controller"
application.register("age-range", AgeRangeController)

import BalanceController from "./balance_controller"
application.register("balance", BalanceController)

import BidIncrementCalculatorController from "./bid_increment_calculator_controller"
application.register("bid-increment-calculator", BidIncrementCalculatorController)

import BidderModeController from "./bidder_mode_controller"
application.register("bidder-mode", BidderModeController)

import BinaryToggleController from "./binary_toggle_controller"
application.register("binary-toggle", BinaryToggleController)

import BreedLoaderController from "./breed_loader_controller"
application.register("breed-loader", BreedLoaderController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import CheckFormController from "./check_form_controller"
application.register("check-form", CheckFormController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import ConditionalFieldsProductionSystemController from "./conditional_fields_production_system_controller"
application.register("conditional-fields-production-system", ConditionalFieldsProductionSystemController)

import ConditionalVisibilityController from "./conditional_visibility_controller"
application.register("conditional-visibility", ConditionalVisibilityController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import CsvboxController from "./csvbox_controller"
application.register("csvbox", CsvboxController)

import DateConstraintController from "./date_constraint_controller"
application.register("date-constraint", DateConstraintController)

import DeliveryController from "./delivery_controller"
application.register("delivery", DeliveryController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import FilteredSearchController from "./filtered_search_controller"
application.register("filtered-search", FilteredSearchController)

import FlowbiteModalController from "./flowbite_modal_controller"
application.register("flowbite-modal", FlowbiteModalController)

import GetSaleAssessmentDetailsController from "./get_sale_assessment_details_controller"
application.register("get-sale-assessment-details", GetSaleAssessmentDetailsController)

import GetVideoIdController from "./get_video_id_controller"
application.register("get-video-id", GetVideoIdController)

import HoverController from "./hover_controller"
application.register("hover", HoverController)

import ImageCropperController from "./image_cropper_controller"
application.register("image-cropper", ImageCropperController)

import InputVisibilityController from "./input_visibility_controller"
application.register("input-visibility", InputVisibilityController)

import KeywordRevealController from "./keyword_reveal_controller"
application.register("keyword-reveal", KeywordRevealController)

import LivestockConfigSelectController from "./livestock_config_select_controller"
application.register("livestock-config-select", LivestockConfigSelectController)

import MediaPositionController from "./media_position_controller"
application.register("media-position", MediaPositionController)

import MltBuilderController from "./mlt_builder_controller"
application.register("mlt-builder", MltBuilderController)

import MultiUploadController from "./multi_upload_controller"
application.register("multi-upload", MultiUploadController)

import MultiplicationController from "./multiplication_controller"
application.register("multiplication", MultiplicationController)

import NavigateController from "./navigate_controller"
application.register("navigate", NavigateController)

import NumberRangeController from "./number_range_controller"
application.register("number-range", NumberRangeController)

import OnecheckedController from "./onechecked_controller"
application.register("onechecked", OnecheckedController)

import PercentageController from "./percentage_controller"
application.register("percentage", PercentageController)

import PicValidatorController from "./pic_validator_controller"
application.register("pic-validator", PicValidatorController)

import PriceAdditionController from "./price_addition_controller"
application.register("price-addition", PriceAdditionController)

import ProgenyCombinedController from "./progeny_combined_controller"
application.register("progeny-combined", ProgenyCombinedController)

import QuickfillhdController from "./quickfillhd_controller"
application.register("quickfillhd", QuickfillhdController)

import RadioOptionsController from "./radio_options_controller"
application.register("radio-options", RadioOptionsController)

import RailsNestedForm from "@stimulus-components/rails-nested-form"
application.register("nested-form", RailsNestedForm)

import RubyUi__AlertDialogController from "./ruby_ui/alert_dialog_controller"
application.register("ruby-ui--alert-dialog", RubyUi__AlertDialogController)

import RubyUi__AccordionController from "./ruby_ui/accordion_controller"
application.register("ruby-ui--accordion", RubyUi__AccordionController)

import RubyUi__CalendarController from "./ruby_ui/calendar_controller"
application.register("ruby-ui--calendar", RubyUi__CalendarController)

import RubyUi__CalendarInputController from "./ruby_ui/calendar_input_controller"
application.register("ruby-ui--calendar-input", RubyUi__CalendarInputController)

import RubyUi__CarouselController from "./ruby_ui/carousel_controller"
application.register("ruby-ui--carousel", RubyUi__CarouselController)

import RubyUi__ChartController from "./ruby_ui/chart_controller"
application.register("ruby-ui--chart", RubyUi__ChartController)

import RubyUi__CheckboxGroupController from "./ruby_ui/checkbox_group_controller"
application.register("ruby-ui--checkbox-group", RubyUi__CheckboxGroupController)

import RubyUi__ClipboardController from "./ruby_ui/clipboard_controller"
application.register("ruby-ui--clipboard", RubyUi__ClipboardController)

import RubyUi__CollapsibleController from "./ruby_ui/collapsible_controller"
application.register("ruby-ui--collapsible", RubyUi__CollapsibleController)

import RubyUi__ComboboxController from "./ruby_ui/combobox_controller"
application.register("ruby-ui--combobox", RubyUi__ComboboxController)

import RubyUi__CommandController from "./ruby_ui/command_controller"
application.register("ruby-ui--command", RubyUi__CommandController)

import RubyUi__ContextMenuController from "./ruby_ui/context_menu_controller"
application.register("ruby-ui--context-menu", RubyUi__ContextMenuController)

import RubyUi__DialogController from "./ruby_ui/dialog_controller"
application.register("ruby-ui--dialog", RubyUi__DialogController)

import RubyUi__DropdownMenuController from "./ruby_ui/dropdown_menu_controller"
application.register("ruby-ui--dropdown-menu", RubyUi__DropdownMenuController)

import RubyUi__FormFieldController from "./ruby_ui/form_field_controller"
application.register("ruby-ui--form-field", RubyUi__FormFieldController)

import RubyUi__HoverCardController from "./ruby_ui/hover_card_controller"
application.register("ruby-ui--hover-card", RubyUi__HoverCardController)

import RubyUi__MaskedInputController from "./ruby_ui/masked_input_controller"
application.register("ruby-ui--masked-input", RubyUi__MaskedInputController)

import RubyUi__PopoverController from "./ruby_ui/popover_controller"
application.register("ruby-ui--popover", RubyUi__PopoverController)

import RubyUi__SelectController from "./ruby_ui/select_controller"
application.register("ruby-ui--select", RubyUi__SelectController)

import RubyUi__SelectItemController from "./ruby_ui/select_item_controller"
application.register("ruby-ui--select-item", RubyUi__SelectItemController)

import RubyUi__SheetContentController from "./ruby_ui/sheet_content_controller"
application.register("ruby-ui--sheet-content", RubyUi__SheetContentController)

import RubyUi__SheetController from "./ruby_ui/sheet_controller"
application.register("ruby-ui--sheet", RubyUi__SheetController)

import RubyUi__SidebarController from "./ruby_ui/sidebar_controller"
application.register("ruby-ui--sidebar", RubyUi__SidebarController)

import RubyUi__TabsController from "./ruby_ui/tabs_controller"
application.register("ruby-ui--tabs", RubyUi__TabsController)

import RubyUi__ThemeToggleController from "./ruby_ui/theme_toggle_controller"
application.register("ruby-ui--theme-toggle", RubyUi__ThemeToggleController)

import RubyUi__TooltipController from "./ruby_ui/tooltip_controller"
application.register("ruby-ui--tooltip", RubyUi__TooltipController)

import SaleAuctionTypeIncrementController from "./sale_auction_type_increment_controller"
application.register("sale-auction-type-increment", SaleAuctionTypeIncrementController)

import SaveAllController from "./save_all_controller"
application.register("save-all", SaveAllController)

import ShrinkCalculatorController from "./shrink_calculator_controller"
application.register("shrink-calculator", ShrinkCalculatorController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import ShearingFormController from "./shearing_form_controller"
application.register("shearing-form", ShearingFormController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import SexOptionsController from "./sex_options_controller"
application.register("sex-options", SexOptionsController)

import SinkableController from "./sinkable_controller"
application.register("sinkable", SinkableController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StickyController from "./sticky_controller"
application.register("sticky", StickyController)

import TermsController from "./terms_controller"
application.register("terms", TermsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ToggleDisplayController from "./toggle_display_controller"
application.register("toggle-display", ToggleDisplayController)

import TotalCalculatorController from "./total_calculator_controller"
application.register("total-calculator", TotalCalculatorController)

import TrimWhitespaceController from "./trim_whitespace_controller"
application.register("trim-whitespace", TrimWhitespaceController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import ValidateController from "./validate_controller"
application.register("validate", ValidateController)

import VerticalStepperController from "./vertical_stepper_controller"
application.register("vertical-stepper", VerticalStepperController)

import RevealController from '@stimulus-components/reveal'
application.register('reveal', RevealController)


// RapidRailsUI Controllers - BEGIN (managed by rapid_rails_ui:install — do not edit by hand)
import { guardCollisions, registerAll } from "../rapid_rails_ui/stimulus_guard"
guardCollisions(application)
registerAll(application, { prefix: "rui" })
// RapidRailsUI Controllers - END
